import { LocationModel, locationModelInitial } from './LocationModel';

export interface LocationBatchModel {
    location: LocationModel,
    classificationsId: number[]
}

export const locationBatchModelInitial: LocationBatchModel = {
    location: locationModelInitial,
    classificationsId: []
};